export default __webpack_public_path__ + "static/media/close-circle-filled-red.daf7d87f.svg";